/* Summit V2: carry equipment lookup context into standard product forms only. */
(function () {
  'use strict';
  var params;
  try { params = new URLSearchParams(window.location.search); } catch (e) { return; }
  var make = (params.get('stp_make') || '').trim();
  var model = (params.get('stp_model') || '').trim();
  if (!make || !model) return;
  if (make.length > 70 || model.length > 70) return;
  var machine = (make + ' ' + model).slice(0, 120);
  var serial = (params.get('stp_serial') || '').trim().slice(0, 80);
  function property(form, name, value) {
    var input = Array.prototype.find.call(form.querySelectorAll('input[name^="properties["]'), function (item) { return item.name === name; });
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.setAttribute('data-stp-lookup-property', 'true');
      form.appendChild(input);
    }
    if (input.hasAttribute('data-stp-lookup-property')) input.value = value;
  }
  function apply(form) {
    if (!form || !form.matches('form[data-product-form]')) return;
    if (form.closest('[data-stp-assembly]') || form.closest('.stp-canon')) return;
    property(form, 'properties[Equipment selected]', machine);
    if (serial) property(form, 'properties[Machine serial number]', serial);
    if (form.querySelector('[data-stp-v2-context-note]')) return;
    var note = document.createElement('p');
    note.setAttribute('data-stp-v2-context-note', '');
    note.setAttribute('role', 'status');
    note.textContent = 'Selected equipment: ' + machine + (serial ? ' · Serial: ' + serial : '') + '. Confirm part fitment before ordering.';
    note.style.cssText = 'background:#f5f5f5;border-left:3px solid #e9ad14;padding:10px 12px;margin:12px 0;color:#252b31;font-size:13px;line-height:1.45';
    form.insertBefore(note, form.firstChild);
  }
  function scan() { document.querySelectorAll('form[data-product-form]').forEach(apply); }
  document.addEventListener('submit', function (event) { apply(event.target); }, true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();
  document.addEventListener('shopify:section:load', scan);
})();